import {
  KATEX_AUTORENDER_ID,
  KATEX_AUTORENDER_URL,
  KATEX_CSS_ID,
  KATEX_CSS_URL,
  KATEX_JS_ID,
  KATEX_JS_URL,
} from '../constants';

let mathRendererPromise = null;

export const ensureMathRenderer = () => {
  if (mathRendererPromise) {
    return mathRendererPromise;
  }

  if (typeof document === 'undefined') {
    return Promise.resolve();
  }

  const ensureStylesheet = () => {
    if (document.getElementById(KATEX_CSS_ID)) {
      return;
    }
    const link = document.createElement('link');
    link.id = KATEX_CSS_ID;
    link.rel = 'stylesheet';
    link.href = KATEX_CSS_URL;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  };

  const ensureScript = (id, src) => {
    return new Promise((resolve, reject) => {
      const existing = document.getElementById(id);
      if (existing) {
        if (existing.getAttribute('data-loaded') === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), {
          once: true,
        });
        return;
      }

      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      script.onload = () => {
        script.setAttribute('data-loaded', 'true');
        resolve();
      };
      script.onerror = () => reject(new Error(`Failed to load ${src}`));
      document.head.appendChild(script);
    });
  };

  mathRendererPromise = new Promise((resolve, reject) => {
    ensureStylesheet();
    ensureScript(KATEX_JS_ID, KATEX_JS_URL)
      .then(() => ensureScript(KATEX_AUTORENDER_ID, KATEX_AUTORENDER_URL))
      .then(resolve)
      .catch(reject);
  });

  return mathRendererPromise;
};
